import React from "react";
import { createRoot } from "react-dom/client";
import CartIQ from "../cartiq-premium-source.jsx";

// window.storage polyfill — the Anthropic preview environment provides this
// natively, but in production we back it with localStorage so persistence
// keeps working. The shape mirrors the platform API:
//   get(key)        → { value: string } | null
//   set(key, value) → void  (value is an opaque string the caller stringifies)
//   delete(key)     → void
// usePersistedState writes JSON-stringified values via set, then reads
// stored.value via get and JSON.parses again. We must not double-encode.
if (!window.storage) {
  window.storage = {
    get(key) {
      try {
        const v = localStorage.getItem(key);
        return v == null ? null : { value: v };
      } catch { return null; }
    },
    set(key, value) {
      try { localStorage.setItem(key, value); } catch {}
    },
    delete(key) {
      try { localStorage.removeItem(key); } catch {}
    },
    keys() {
      try { return Object.keys(localStorage); } catch { return []; }
    },
  };
}

createRoot(document.getElementById("root")).render(<CartIQ />);
